import React, { useState, useEffect, useMemo } from "react";
import AddUnit from "../Component/AddUnit";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Button, ButtonGroup, Col, Input, InputGroup, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import UnitService from "../../../Services/QRCodeServices/UnitService/UnitService";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import EditUnit from "../Component/EditUnit";

const Unit = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState([]);
  const [selectedEditItem, setSelectedEditItem] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [pagination, setPagination] = useState({
      currentPage: 1,
      pageSize: 10,
      totalPages: 0,
      totalData: 0
    });

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const toggleEditModal = () => {
    setEditModalOpen(!editModalOpen);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

const fetchData = async (pageNumber = 1, pageSize = 10) => {
  setLoading(true);
  try {
    const response = await UnitService.getList({ pageNumber, pageSize });
    if (response && response.data && Array.isArray(response.data)) {
      setData(response.data); // Set the array of items to `data`
      setPagination({
        currentPage: response.currentPage || pageNumber,
        pageSize: response.pageSize || pageSize,
        totalPages: response.totalPages,
        totalData: response.totalData,
      });
    } else {
      console.error("Invalid response structure:", response);
      setData([]);
    }
    
  } catch (error) {
    console.error("Error fetching data:", error);
    toast.error("Failed to fetch data.");
    setData([]); // Ensure `data` is always an array
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchData();
  }, []);

  const anyModalJustClosed = useMemo(() => {
    return !editModalOpen || !modalOpen || !deleteModal;
  }, [editModalOpen, modalOpen, deleteModal]);

  useEffect(() => {
    if (anyModalJustClosed) {
      fetchData();
    }
  }, [anyModalJustClosed]);

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      console.log(
        "🚀 ~ handleDelete ~ selectedDeleteItem:",
        selectedDeleteItem.id
      );
      try {
        await UnitService.delete(selectedDeleteItem.id);
        setDataList((prevList) =>
          prevList.filter((item) => item.id !== selectedDeleteItem.id)
        );
        toast.success("Currency deleted successfully");
      } catch (error) {
        console.log("🚀 ~ handleDelete ~ error:", error);
        toast.error("Failed to delete the currency");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
        fetchData();
      }
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };

  const handleEditClick = (item) => {
    setSelectedEditItem(item);
    toggleEditModal();
  };
  const [filterText, setFilterText] = useState("");
  const filteredData = Array.isArray(data)
  ? data.filter((item) => {
      const searchText = filterText.toLowerCase();
      return item?.title?.toLowerCase().includes(searchText);
    })
  : [];

  console.log("Data", data);
  console.log("filtered data", filteredData);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => (
        <Link to={`/currency/detail/${row?.id}`}>{row?.title}</Link>
      ),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => `${row?.description || "N/A"}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleEditClick(row)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            onClick={() => handleDeleteClick(row)}
            style={{ width: "30px", height: "30px" }}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Unit List" pageTitle="Unit" />
      </div>
      <Row>
        <Col md={5} xs={6} className="px-xs-1">
          <InputGroup>
            <Input
              placeholder="Search by name"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col
          md={7}
          xs={6}
          className="d-flex justify-content-end align-items-end mb-3"
        >
          <Button className="package-button px-1 px-sm-2" onClick={toggleModal}>
            Add New Unit
          </Button>
        </Col>
      </Row>

      <CustomDataTable
  responsive
  striped
  pagination
  fixedHeader
  persistTableHead
  progressPending={loading}
  columns={columns}
  data={filteredData}
  customStyles={{
    headCells: {
      style: {
        fontSize: "0.93rem",
        fontWeight: 610,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  }}
  paginationServer // Enables server-side pagination
  paginationTotalRows={pagination.totalData} // Total number of rows from backend
  onChangePage={(page) => fetchData(page, pagination.pageSize)} // Handles page change
  onChangeRowsPerPage={(newPageSize) => {
    setPagination((prev) => ({ ...prev, pageSize: newPageSize }));
    fetchData(1, newPageSize); // Fetch first page with the new page size
  }}
  progressComponent={
    <div className="my-3">
      <Triangle
        visible={true}
        height="80"
        width="80"
        color="#5B71B9"
        ariaLabel="triangle-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
      <h5 className="mt-1">Loading...</h5>
    </div>
  }
/>


      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem}
      />
      <AddUnit
        isOpen={modalOpen}
        toggleModal={toggleModal}
        refreshData={fetchData}
      />
      <EditUnit
        isOpen={editModalOpen}
        toggleModal={toggleEditModal}
        data={selectedEditItem}
        refreshData={fetchData}
      />
    </div>
  );
};

export default Unit;
